import { Card, CardContent } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CardTitle from "@saleor/components/CardTitle";
import { InstagramDetails_instagram_instagramtag } from "@saleor/instagram/types/InstagramDetails";
import { renderCollection } from "@saleor/misc";
import { ListActions, PageListProps } from "@saleor/types";
import React from "react";
import { useIntl } from "react-intl";

import InstagramTagList from "../InstagramTagList";

export interface InstagramTagListPageProps extends PageListProps, ListActions {
  image: string;
  mimeType: string;
  instagramTag: InstagramDetails_instagram_instagramtag[];
  // deleteInsTag: (id: string) => void;
}

const useStyles = makeStyles(
  {
    pcfdiv: {
      width: 315,
      height: 315,
      position: "relative"
    },
    pcmc: {
      width: 315,
      height: 315,
      display: "block",
      position: "relative",
      zIndex: 2,
      borderLeft: "25.2px solid rgba(0,0,0,.5)",
      borderRight: "25.2px solid rgba(0,0,0,.5)",
      borderTop: "32.025px solid rgba(0,0,0,.5)",
      borderBottom: "32.025px solid rgba(0,0,0,.5)",
      padding: 0,
      margin: 0
    },
    pcimage: {
      width: 315,
      height: 315,
      objectFit: "cover",
      display: "block",
      position: "absolute",
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      zIndex: 1
    },
    Mobilefdiv: {
      lineHeight: 0,
      width: 315,
      // minHeight:315,
      position: "relative",
      marginLeft: 70,
      height: "fit-content"
    },
    Mobilemc: {
      top: 0,
      left: 0,
      height: "100%",
      display: "block",
      position: "absolute",
      width: "100%",
      borderLeft: "30.24px solid rgba(0,0,0,.5)",
      borderRight: "30.24px solid rgba(0,0,0,.5)",
      borderTop: "50.4px solid rgba(0,0,0,.5)",
      borderBottom: "31.92px solid rgba(0,0,0,.5)",
      zIndex: 2
    },
    Mobileimage: {
      width: 315
      // height: 315,
      // objectFit: "cover",
      // display: "block",
      // zIndex: 1,
      // position: "absolute",
      // top: 0,
      // left: 0,
      // bottom: 0,
      // right: 0
    },
    TagTriangle: {
      width: 0,
      height: 0,
      borderWidth: 6,
      borderStyle: "solid",
      bottom: "-12px",
      position: "absolute",
      borderColor: "#000 transparent transparent transparent",
      color: "#ffff"
    },
    PCTag: {
      width: 105,
      height: 29.4,
      borderRadius: 4,
      border: 0,
      backgroundColor: "rgb(0,0,0,0.8)",
      position: "absolute",
      zIndex: 999,
      marginTop: -34.39
    },
    MobileTag: {
      width: 134.4,
      height: 33.6,
      borderRadius: 4,
      border: 0,
      backgroundColor: "rgb(0,0,0,0.8)",
      position: "absolute",
      zIndex: 999,
      marginTop: -39.6,
      lineHeight: "20px",
      marginBottom: "10px"
      // overflow:"hidden",
    },
    textV: {
      fontSize: 1,
      color: "#FFFFFF",
      zIndex: 999,
      marginLeft: 7,
      marginTop: 5,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      width: "80%"
    },
    MtextV: {
      fontSize: 13,
      color: "#FFFFFF",
      zIndex: 999,
      marginLeft: 7,
      marginTop: 7,
      marginBottom: 0,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      width: "80%"
    }
  },
  { name: "InstagramTagListPage" }
);

const InstagramTagListPage: React.FC<InstagramTagListPageProps> = ({
  image,
  instagramTag,
  disabled,
  mimeType,
  // deleteInsTag,
  ...InstagramTagListPageProps
}) => {
  const classes = useStyles();

  const intl = useIntl();

  return (
    <>
      <Card>
        <CardTitle
          title={intl.formatMessage({
            defaultMessage: "Tag Management",
            description: "Tag Management"
          })}
        />
        <CardContent style={{ textAlign: "center" }}>
          <div style={{ padding: 20, display: "flex", alignItems: "center" }}>
            <div className={classes.pcfdiv}>
              <div className={classes.pcmc} />
              {renderCollection(instagramTag, (tag, index) => (
                <div key={index}>
                  {tag.pcx < 30 ? (
                    <div
                      className={classes.PCTag}
                      style={{
                        top: `${tag?.pcy}%`,
                        left: `${tag?.pcx}%`,
                        marginLeft: -17.55
                      }}
                    >
                      <p className={classes.textV}>
                        {tag.productvariant?.product?.name +
                          " " +
                          tag.productvariant?.attributes[0]?.values[0]?.value}
                      </p>

                      <div
                        className={classes.TagTriangle}
                        style={{ left: 11.55 }}
                      />
                    </div>
                  ) : tag.pcx < 70 ? (
                    <div
                      className={classes.PCTag}
                      style={{
                        top: `${tag?.pcy}%`,
                        left: `${tag?.pcx}%`,
                        marginLeft: -49.5
                      }}
                    >
                      <p className={classes.textV}>
                        {tag.productvariant?.product?.name +
                          " " +
                          tag.productvariant?.attributes[0]?.values[0]?.value}
                      </p>

                      <div
                        className={classes.TagTriangle}
                        style={{ left: 43.5 }}
                      />
                    </div>
                  ) : (
                    <div
                      className={classes.PCTag}
                      style={{
                        top: `${tag?.pcy}%`,
                        left: `${tag?.pcx}%`,
                        marginLeft: -93.45
                      }}
                    >
                      <p className={classes.textV}>
                        {tag.productvariant?.product?.name +
                          " " +
                          tag.productvariant?.attributes[0]?.values[0]?.value}
                      </p>
                      <div
                        className={classes.TagTriangle}
                        style={{ right: 11.55 }}
                      />
                    </div>
                  )}
                </div>
              ))}
              {mimeType === "image/jpeg" && (
                <img className={classes.pcimage} src={image}></img>
              )}
              {mimeType === "video/mp4" && (
                <video className={classes.pcimage}>
                  <source className={classes.pcimage} src={image}></source>
                </video>
              )}
            </div>

            <div className={classes.Mobilefdiv}>
              <div className={classes.Mobilemc} />
              {renderCollection(instagramTag, (tag, index) => (
                <div key={index}>
                  {tag.mbx < 30 ? (
                    <div
                      className={classes.MobileTag}
                      style={{
                        top: `${tag?.mby}%`,
                        left: `${tag?.mbx}%`,
                        marginLeft: -17.55
                      }}
                    >
                      <p className={classes.MtextV}>
                        {tag.productvariant?.product?.name +
                          " " +
                          tag.productvariant?.attributes[0]?.values[0]?.value}
                      </p>
                      <div
                        className={classes.TagTriangle}
                        style={{ left: 11.55 }}
                      />
                    </div>
                  ) : tag.mbx < 70 ? (
                    <div
                      className={classes.MobileTag}
                      style={{
                        top: `${tag?.mby}%`,
                        left: `${tag?.mbx}%`,
                        marginLeft: -49.5
                      }}
                    >
                      <p className={classes.MtextV}>
                        {tag.productvariant?.product?.name +
                          " " +
                          tag.productvariant?.attributes[0]?.values[0]?.value}
                      </p>
                      <div
                        className={classes.TagTriangle}
                        style={{ left: 43.5 }}
                      />
                    </div>
                  ) : (
                    <div
                      className={classes.MobileTag}
                      style={{
                        top: `${tag?.mby}%`,
                        left: `${tag?.mbx}%`,
                        marginLeft: -115.45
                      }}
                    >
                      <p className={classes.MtextV}>
                        {tag.productvariant?.product?.name +
                          " " +
                          tag.productvariant?.attributes[0]?.values[0]?.value}
                      </p>
                      <div
                        className={classes.TagTriangle}
                        style={{ right: 11.55 }}
                      />
                    </div>
                  )}
                </div>
              ))}
              {mimeType === "image/jpeg" && (
                <img className={classes.Mobileimage} src={image}></img>
              )}
              {mimeType === "video/mp4" && (
                <video className={classes.Mobileimage}>
                  <source className={classes.Mobileimage} src={image}></source>
                </video>
              )}
            </div>
          </div>
          <InstagramTagList
            instagramTag={instagramTag}
            disabled={disabled}
            // deleteInsTag={deleteInsTag}
            {...InstagramTagListPageProps}
          />
        </CardContent>
      </Card>
    </>
  );
};

export default InstagramTagListPage;
